import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomeView from './pages/Home/HomeView';
import SessionsView from './pages/Sessions/SessionsView';
import SettingsView from './pages/Settings/SettingsView';
import { ROUTES } from './routes';

const App = () => {
  const { search } = useLocation();

  return (
    <Routes>
      <Route path={ROUTES.tourPlanner} element={<HomeView />} />
      <Route path={ROUTES.sessions} element={<SessionsView />} />
      <Route path={ROUTES.settings} element={<SettingsView />} />
      <Route
        path="*"
        element={<Navigate to={{ pathname: ROUTES.tourPlanner, search }} replace />}
      />
    </Routes>
  );
};

export default App;
